import { Injectable } from '@angular/core';
import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

@Injectable()
export class EnabledVariousLocationV4 implements IFlagFeature {
  name = Features.ENABLE_VARIOUS_LOCATION_V4;
  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}
